import $ from 'jquery';
import { SubscriptionFormPromise } from '../../objects/product/Subscription';


const KEY = 'Qnpf3X'; //api public key
const URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
const PLATFORM = 'shopify';


export const backInStockForm = (form, formSelector, messageDefaultSelector, messageSuccessSelector, errorMsgSelector ) => {
  
  backInStockPromise(form)
    .then((data) => {
      if (data.success) {
        formSelector.find(messageDefaultSelector).removeClass('is-active');
        formSelector.find(messageSuccessSelector).addClass('is-active');
        formSelector.find(errorMsgSelector).removeClass('is-active');
        form.addClass('is-hidden');
      }
    })
    .catch((error) => {
      formSelector.find(errorMsgSelector).removeClass('is-active').addClass('is-active');
      form.find(errorMsgSelector).html(error);
    });

    SubscriptionFormPromise(form)
      .then((data) => {
        if (data.success) {
          
        }
      })
      .catch((error) => {
        formSelector.find(errorMsgSelector).removeClass('is-active').addClass('is-active');
        form.find(errorMsgSelector).html(error);
      });

}

const backInStockPromise = (form) => {

  return new Promise((resolve, reject) => {

  if (!form) throw 'Invalid input';
  let email = form.find('input[type="email"]').val();
  let variant = form.find('input[name="variant"]').val();

  let re = /\S+@\S+\.\S+/;

  if (!email || !re.test(email)) throw 'Invalid input';
  if (!variant) throw 'Invalid variant';

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: URL,
      data: { a: KEY, email: email, variant: variant, platform: PLATFORM },

      success: data => {
        try {
          if (data.success) resolve(data);
        } catch (ex) {
          return reject(ex);
        }
      },
      error: (jqXHR, status, error) => reject(error)
    });
  });
}